<template>
  <div class="OutBoundHistoryTable">
    <PaginationController
      v-model="archivedShipments"
      getDataActionName="getArchivedShipments"
      :historyLimit="25"
      :searchBoxLabel="$t('searchByUPC/ASIN/OrderId/Tracking')"
      :searchBoxHint="$t('outBoundHistorySearchBoxHint')"
      :select="isOrganization ? warehouseSelected : selectedOrg"
      :actionPredicates="actionPredicates"
      isUsingModelInAction
      haveSearchBox
      haveStartDate
      :showSearchBoxLabel="!Boolean(upc)"
      :initSearchValue="upc"
      :startDate="preDate"
      ref="pagination"
    >
      <template v-slot:dataTable>
        <v-data-table
          v-model="selectedRows"
          :headers="headers"
          :items="archivedShipments"
          :expand="expand"
          item-key="_key"
          hide-actions
          :select-all="isWarehouse"
          :search="filterText"
        >
          <template v-slot:items="props">
            <OutboundShipmentRow
              type="history"
              isHideStar
              :props="props"
              :item="props.item"
              :index="props.index"
              :expanded.sync="props.expanded"
              :siteName="
                getSiteName(
                  props.item.products[0] && props.item.products[0].warehouseSite
                )
              "
              @show-details="item => showDetails(item)"
              @show-comments-history="item => showDraftComments(item, 'history')"
            />
          </template>
          <template v-slot:expand="props">
            <v-card>
              <v-card-text>
                <v-layout justify-space-around>
                  <v-flex sm8>
                    <v-layout>
                      <v-flex sm5>
                        <v-layout column v-if="isOrganization">
                          <div>
                            <b>{{ $t("notes") }}:</b>
                          </div>
                          <div style="whiteSpace: pre-wrap; overflow-wrap: break-word; max-width: 30vw;">{{ props.item.note }}</div>
                        </v-layout>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex sm5>
                        <v-layout column>
                          <div>
                            <b>{{ $t("instructions") }}:</b>
                          </div>
                          <div style="whiteSpace: pre-wrap; overflow-wrap: break-word; max-width: 30vw;">{{ props.item.instruction }}</div>
                          <div v-if="!props.item.isMPS"><p style="margin:0" v-for="item in props.item.labels" :key="item.orderId">{{item.trackingNum}} ->{{displayPackaging(item.packaging)}}</p></div>
                            <div v-else>
                              <div v-for="item in props.item.labels.reduce((merge, label, index) => {
                                const {length,width,height} = label.packaging
                                const labelPkg = `${length}-${width}-${height}`
                                if(index === 0) props.item.pkgMerge = {}
                                if (!props.item.pkgMerge[labelPkg]) {
                                  props.item.pkgMerge[labelPkg] = true
                                  label.pkgQty = 1
                                  merge.push(label)
                                } else {
                                  const targetIndex = merge.findIndex(({packaging}) => packaging.length === length && packaging.width === width && packaging.height === height)
                                  targetIndex !== -1 && (merge[targetIndex].pkgQty += 1)
                                }
                                return merge
                                },[])" :key="item.orderId">{{displayPackaging(item.packaging)}}{{item.pkgQty === 1 ?
                                  (item.carrier.includes('CWT') ? `&nbsp;&nbsp; * &nbsp;&nbsp; ${(props.item.trackingNumbers && props.item.trackingNumbers.length) || 1}` : ''):
                                  `&nbsp;&nbsp; * &nbsp;&nbsp;${item.pkgQty}`}}
                              </div>
                              <div>{{props.item.trackingNumbers && props.item.trackingNumbers.join(' ')}}</div>
                            </div>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </template>
        </v-data-table>
      </template>
      <template v-slot:beforeSearchBox>
        <v-flex xs3 mr-5 v-if="isWarehouse && !hideSelectedSites">
          <v-autocomplete
            :items="warehousesSitesOptions"
            item-text="siteName"
            item-value="key"
            v-model="siteKey"
            :label="$t('warehouseSite')"
          ></v-autocomplete>
        </v-flex>
        <template v-if="isOrganization">
          <v-flex xs3 mr-2>
          <v-autocomplete
            :items="searchModeOptions"
            item-text="modeName"
            item-value="modeKey"
            v-model="searchMode"
            :label="$t('searchMode')"
          ></v-autocomplete>
        </v-flex>
          <v-flex md4 v-if="searchMode === 'site'">
          <v-autocomplete
            :items="warehousesSitesOptions"
            item-text="siteName"
            item-value="key"
            v-model="siteKey"
            :label="$t('warehouseSite')"
          ></v-autocomplete>
        </v-flex>
        <v-flex md4 v-else>
          <v-autocomplete
            :items="usersOptions"
            item-text="name"
            item-value="uid"
            v-model="warehouseSelected"
            :label="$t('user')"
          ></v-autocomplete>
        </v-flex>
        </template>
        <v-flex md4 v-else>
          <v-autocomplete
            v-model="selectedOrg"
            :items="organizationSelect"
            :label="$t('organization')"
            item-text="displayName"
            item-value="key"
          ></v-autocomplete>
        </v-flex>
      </template>
      <template v-slot:afterDate>
        <v-flex md4>
        <v-btn
          small
          color="primary"
          v-if="isWarehouse"
          @click="exportExcel"
          :loading="exportLoading"
        >{{ $t('export') }}</v-btn>
        <v-btn
          small
          color="primary"
          v-if="isOrganization"
          @click="showOrgExportDialog = true"
          class="ml-2"
        >{{ $t('export') }}</v-btn>
      </v-flex>
        <v-flex xs4>
          <v-text-field
            :label="$t('filter')"
            v-model="filterText"
            clearable
          ></v-text-field>
        </v-flex>
      </template>
    </PaginationController>

    <ChatRoom
      :title="$t('attachmentDetails')"
      v-model="photoServiceDialog"
      v-if="photoServiceDialog"
      enableFileUpload
      createConnection
      noLastRead
      v-bind="chatRoomBind"
    >
     <template v-slot:issue>
        <v-card hover raised>
          <v-card-text>
            <v-layout>
              <v-flex xs5 lg3 class="text-xs-left">
                <span class="cardTitle">{{ $t('shipmentID') }}:</span> {{archivedShipmentInEdit.shipmentKey}}
              </v-flex>
              <v-flex xs6 class="text-xs-left" v-if="archivedShipmentInEdit.trackingNum">
                <span class="cardTitle">{{ $t('tracking') }}:</span> {{archivedShipmentInEdit.trackingNum}}
              </v-flex>
            </v-layout>
            <div class="cardTitle" style="overflow-wrap: break-word;">
              <span class="cardTitle">{{ $t('shipmentLabel') }}:</span>
              <v-btn
                color="primary"
                flat
                @click="getShipmentLabel(archivedShipmentInEdit)"
              >{{ $t('download') }}</v-btn>
            </div>
            <div v-if="archivedShipmentInEdit.snRecords.length" class="cardtext"><span class="cardTitle">{{ $t('sn') }}:</span> {{archivedShipmentInEdit.snRecords.join(', ')}}</div>
            <template v-if="outboundAttachments.length">
              <div style="overflow-wrap: break-word;">
                <span class="cardTitle">{{ $t('photos') }}:</span>
              </div>
              <v-layout row wrap>
                <FsFileChip
                  v-for="(file, index) in outboundAttachments"
                  :file="file"
                  :key="'file' + index"
                  width="100%"
                  aspect-ratio="1.7"
                  class="ma-2"
                />
              </v-layout>
            </template>
            <div style="overflow-wrap: break-word;" v-if="isWarehouse && archivedShipmentInEdit.workerName">
              <v-layout>
                <v-flex xs5 lg3>
                  <span class="cardTitle">{{ $t('operator') }}:</span> {{ archivedShipmentInEdit.workerName }}
                </v-flex>
                <v-flex xs6>
                  <span class="cardTitle">{{ $t('confirmType') }}:</span> {{ $t(archivedShipmentInEdit.confirmType) || $t('standardConfirm') }}
                </v-flex>
              </v-layout>
            </div>
            <div style="overflow-wrap: break-word;" v-if="isOrganization && archivedShipmentInEdit.creator">
              <span class="cardTitle">{{ $t('creator') }}:</span> {{ archivedShipmentInEdit.creator }}
            </div>
            <div style="overflow-wrap: break-word;" v-if="isOrganization && archivedShipmentInEdit.cancelerName">
              <span class="cardTitle">{{ $t('canceler') }}:</span> {{ archivedShipmentInEdit.cancelerName }}
            </div>
            <div style="overflow-wrap: break-word;" v-if="isWarehouse && archivedShipmentInEdit.pickupId">
              <span class="cardTitle">{{ $t('pickupId') }}: </span> {{ archivedShipmentInEdit.pickupId }}
            </div>
            <div style="overflow-wrap: break-word;" v-if="isWarehouse && archivedShipmentInEdit.scannedItems && archivedShipmentInEdit.scannedItems.length">
              <span class="cardTitle">{{ $t('shipmentFulfillment') }}: </span>
            </div>
            <v-data-table
              v-if="isWarehouse && archivedShipmentInEdit.scannedItems && archivedShipmentInEdit.scannedItems.length"
              :headers="[
                { text: 'Upc', value: 'upc', align: 'left', sortable: false },
                { text: $t('requiredQuantity'), value: 'requiredQuantity', align: 'left', sortable: false },
                { text: $t('quantity'), value: 'quantity', align: 'left', sortable: false }
              ]"
              :items="archivedShipmentInEdit.scannedItems || []"
              item-key="upc"
              hide-actions
            >
              <template v-slot:items="{item}">
                  <td class="text-xs-left">{{ item.upc }}</td>
                  <td class="text-xs-left">{{ item.requiredQuantity }}</td>
                  <td class="text-xs-left">{{ item.quantity }}</td>
              </template>
            </v-data-table>
            <span class="cardTitle" style="overflow-wrap: break-word;" v-if="isWarehouse && archivedShipmentInEdit.uploadedTrackings && archivedShipmentInEdit.uploadedTrackings.length">
              {{ $t('scannedTrackings') }}:
            </span>
            <span style="overflow-wrap: break-word;" v-if="isWarehouse && archivedShipmentInEdit.scannedItems && archivedShipmentInEdit.scannedItems.length">
              {{ archivedShipmentInEdit.uploadedTrackings && archivedShipmentInEdit.uploadedTrackings.join(', ') }}
            </span>
            <template v-if="formattedIMEIRecords.length">
              <div style="overflow-wrap: break-word;">
                <span class="cardTitle">{{ $t('IMEIRecords') }}: </span>
              </div>
              <v-data-table
                  :headers="[
                    { text: $t('tracking'), value: 'index', align: 'left', sortable: false, width: '15%'},
                    { text: $t('upc'), value: 'upc', align: 'left', sortable: false, width: '15%'},
                    { text: $t('quantity'), value: 'quantity', align: 'left', sortable: false,  width: '15%' },
                    { text: $t('IMEI'), value: 'IMEIs', align: 'center', sortable: false,  width: '60%'}
                  ]" :items="formattedIMEIRecords" hide-actions item-key="index">
                    <template v-slot:items="props">
                      <td class="text-xs-left">
                        {{props.item.tracking}}
                      </td>
                      <td class="text-xs-left">{{ props.item.upc }}</td>
                      <td class="text-xs-left">{{ props.item.IMEIs.length }}</td>
                      <td class="text-xs-left">
                        {{ props.item.IMEIs.join(',') }}
                      </td>
                    </template>
                </v-data-table>
            </template>
          </v-card-text>
        </v-card>
      </template>
    </ChatRoom>

    <ChatRoom
      :title="$t('DraftComments')"
      v-model="draftCommentDialog"
      v-if="draftCommentDialog"
      enableFileUpload
      createConnection
      :readOnly="!draftInEdit.isDraft"
      commentsField="draftComments"
      v-bind="chatRoomBind"
    >
     <template v-slot:issue>
        <v-card hover raised>
          <v-card-text>
            <div class="chatroom-text-block">
              <span>{{ $t('shipmentID') }}: {{ draftInEdit.requestId || draftInEdit._key }}</span>
              <span>{{ $t('createTime') }}: {{ toTimestampString(draftInEdit.createTime) }}</span>
            </div>
            <div class="chatroom-text-block">
              <span>{{ $t('tracking') }}: {{ draftInEdit.trackingNum }}</span>
              <span>{{ $t('packageQuantity') }}: {{ draftInEdit.packageQty }}</span>
            </div>
            <div class="chatroom-text-block">
              <span>{{ $t('totalCost') }}: ${{ (Object.values(draftInEdit.products) || []).reduce((acc, item) => acc + (item.toShip * (item.unitCost || 0)), 0).toLocaleString() }}</span>
              <span>{{ $t('totalPrice') }}: ${{ (Object.values(draftInEdit.products) || []).reduce((acc, item) => acc + (item.toShip * (item.unitPrice || 0)), 0).toLocaleString() }}</span>
            </div>
            <div class="chatroom-text-block">
              <span>{{ $t('destination') }}: {{ draftInEdit.destination && ((draftInEdit.destination.name === '-- Other --') ? draftInEdit.destination.content : draftInEdit.destination.name) }}</span>
            </div>
            <div>
              {{ $t('products') }}:
            </div>
            <v-layout>
              <v-flex>
                <v-data-table
                  v-if="JSON.stringify(draftInEdit.products) !== '{}'"
                  :headers="[
                    { text: '#', value: '', align: 'left', sortable: false },
                    { text: $t('productName'), value: 'productName', align: 'left', sortable: true },
                    { text: 'UPC', value: '', align: 'left', sortable: false },
                    { text: `${$t('quantity')}(${Object.values(draftInEdit.products).reduce((acc, item) => acc + item.toShip, 0)})`, value: '', align: 'left', sortable: false },
                    { text: $t('unitCost'), value: '', align: 'left', sortable: false },
                    { text: $t('unitPrice'), value: '', align: 'left', sortable: false },
                    { text: $t('totalCost'), value: '', align: 'left', sortable: false },
                    { text: $t('totalPrice'), value: '', align: 'left', sortable: false }
                  ]"
                  :items="Object.values(draftInEdit.products).map(item => {
                    return {...item, productName: getUpcName(item)}
                  })"
                  item-key="fbmKey"
                  class="elevation-1"
                  hide-actions
                >
                  <template v-slot:items="{item, index}">
                      <td class="text-xs-left">{{ index + 1 }}</td>
                      <td class="text-xs-left">{{ item.productName }}</td>
                      <td class="text-xs-left">
                        {{ item.upc }}
                      </td>
                      <td class="text-xs-left">
                        {{ item.toShip }}
                      </td>
                      <td class="text-xs-left">
                        ${{ (item.unitCost || 0).toLocaleString() }}
                      </td>
                      <td class="text-xs-left">
                        ${{ (item.unitPrice || 0).toLocaleString() }}
                      </td>
                      <td class="text-xs-left">
                        ${{ (item.toShip * (item.unitCost || 0)).toLocaleString() }}
                      </td>
                      <td class="text-xs-left">
                        ${{ (item.toShip * (item.unitPrice || 0)).toLocaleString() }}
                      </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <div class="chatroom-text-block" style="overflow-wrap: break-word; white-space: pre-wrap;">
              <span>{{ $t('note') }}: {{ draftInEdit.note }}</span>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </ChatRoom>

    <FormSubmitPopup
      v-if="showOrgExportDialog"
      v-model="showOrgExportDialog"
      :title="$t('exportShipmentHistory')"
      :rightMethod="exportOrgData"
      @popupClose="() => {
        showOrgExportDialog = false
        orgExportSiteKey = ''
        orgExportLoading = false
      }"
      :rightButtonLoading="orgExportLoading"
    >
      <template v-slot:input>
        <v-layout column>
          <v-flex xs12 mb-3>
            <v-flex>
              <v-select
                :items="timeZones"
                v-model="timeZone"
                :label="$t('timeZone')"
                style="min-width: 100px"
              ></v-select>
              <DatePicker
                :isShowIcon="false"
                label="date"
                range
                v-model="dates"
                mode="date"
                :max="dateMax"
                :min="dateMin"
              />
            </v-flex>
          </v-flex>

          <v-flex xs12>
            <v-autocomplete
              :items="warehousesSitesOptions"
              item-text="siteName"
              item-value="key"
              v-model="orgExportSiteKey"
              :label="$t('warehouseSite')"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </template>
    </FormSubmitPopup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PaginationController from './PaginationController'
import OutboundShipmentRow from './OutboundShipmentRow'
import ChatRoom from './ChatRoom'
import { toTimestampString, exportExcelFile, toDateStart, timeTools, exportListToXlsx } from '../utils/tools'
import FsFileChip from './FsFileChip'
import FormSubmitPopup from './FormSubmitPopup'
import DatePicker from './DatePicker'
export default {
  name: 'OutBoundHistoryTable',
  components: {
    PaginationController,
    OutboundShipmentRow,
    ChatRoom,
    FsFileChip,
    FormSubmitPopup,
    DatePicker
  },
  props: {
    expand: {
      type: Boolean,
      default: false
    },
    upc: {
      type: String,
      default: ''
    },
    hideSelectedSites: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const now = new Date()
    const weekTime = 7 * 60 * 60 * 24 * 1000
    const weekAgo = new Date(now.getTime() - weekTime)
    return {
      warehouseSelected: '',
      selectedOrg: '',
      siteKey: '',
      archivedShipments: [],
      archivedShipmentInEdit: {},
      outboundAttachments: [],
      photoServiceDialog: false,
      chatRoomBind: {},
      draftInEdit: {},
      draftCommentDialog: false,
      selectedRows: [],
      exportLoading: false,
      filterText: '',
      preDate: toDateStart(new Date(new Date().setFullYear(new Date().getFullYear() - 1))),
      searchModeOptions: [
        { modeName: this.$t('user'), modeKey: 'user' },
        { modeName: this.$t('site'), modeKey: 'site' }
      ],
      searchMode: 'user',
      showOrgExportDialog: false,
      orgExportSiteKey: '',
      orgExportLoading: false,
      dates: [weekAgo, now],
      timeZone: '0'
    }
  },
  mixins: [timeTools],
  computed: {
    ...mapGetters([
      'activeOrganization',
      'activeWarehouse',
      'users',
      'warehouses',
      'warehousesSites',
      'sortedWarehouseOrganizations'
    ]),
    timeZones () {
      return [
        {
          text: this.$t('currentZone'),
          value: '0'
        },
        {
          text: this.$t('UTC'),
          value: '1'
        }
      ]
    },
    dateMin () {
      const [startDate, endDate] = this.dates
      if (startDate && endDate) return undefined
      if (startDate) {
        const weekTime = 7 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() - weekTime
        return new Date(time).toISOString()
      }
      return undefined
    },
    dateMax () {
      const [startDate, endDate] = this.dates
      const now = new Date()
      if (startDate && endDate) return now.toISOString()
      if (startDate) {
        const weekTime = 7 * 60 * 60 * 24 * 1000
        const time = startDate.getTime() + weekTime
        return now.getTime() < time ? now.toISOString() : new Date(time).toISOString()
      }
      return now.toISOString()
    },
    usersOptions () {
      return [{name: `-- ${this.$t('all')} --`, uid: ''}, ...this.warehousesOptions, ...this.users]
    },
    warehousesOptions () {
      return this.warehouses && this.warehouses.length > 0 ? this.warehouses.map(warehouse => { return {name: warehouse.warehouseName, uid: warehouse.warehouseKey} }) : []
    },
    isOrganization () {
      return !!this.activeOrganization
    },
    isWarehouse () {
      return !!this.activeWarehouse
    },
    actionPredicates () {
      let predicates = []
      if (this.siteKey) {
        predicates.push({
          field: 'siteKey',
          compare: '==',
          value: this.siteKey
        })
      }
      return predicates
    },
    headers () {
      const productsQty = this.archivedShipments.reduce((acc, item) => acc + item.products.reduce((total, prod) => total + prod.toShip, 0), 0)
      if (this.isOrganization) {
        return [
          { text: '#', value: '', align: 'center', sortable: false },
          { text: this.$t('info'), value: '_key', align: 'left', sortable: false, width: '5%' },
          { text: this.$t('serviceType'), value: 'isExpedited', align: 'left', sortable: false },
          { text: `${this.$t('outboundShipmentQuantity')}(${productsQty})`, value: 'requestId', align: 'left', sortable: false },
          { text: this.$t('shipmentID'), value: 'shipmentId', align: 'left', sortable: false },
          { text: this.$t('tracking#'), value: 'trackingNum', align: 'left', sortable: false },
          {
            text: `${this.$t('pkgQty')}(${this.archivedShipments.reduce((acc, item) => acc + item.packageQty, 0)})`,
            value: 'packageQty',
            align: 'left',
            sortable: false,
            width: '1%'
          },
          { text: this.$t('destination'), value: 'destinationForDisplay', align: 'left', sortable: false },
          { text: `${this.$t('createTime')}${' / ' + this.$t('confirmTime')}`, value: 'createTime', align: 'left', sortable: false },
          { text: this.$t('actions'), value: 'keywordString', align: 'center', sortable: false, width: '20%' }
        ]
      } else {
        return [
          { text: '#', value: '', align: 'center', sortable: false },
          { text: this.$t('info'), value: '_key', align: 'left', sortable: false, width: '5%' },
          { text: this.$t('serviceType'), value: 'isExpedited', align: 'left', sortable: false },
          { text: `${this.$t('outboundShipmentQuantity')}(${productsQty})`, value: 'requestId', align: 'left', sortable: false },
          { text: this.$t('tracking#'), value: 'trackingNum', align: 'left', sortable: false },
          {
            text: `${this.$t('pkgQty')}(${this.archivedShipments.reduce((acc, item) => acc + item.packageQty, 0)})`,
            value: 'packageQty',
            align: 'left',
            sortable: false,
            width: '1%'
          },
          { text: `${this.$t('createTime')} / ${this.$t('confirmTime')}`, value: 'createTime', align: 'left', sortable: false },
          { text: this.$t('actions'), value: 'keywordString', align: 'center', sortable: false, width: '20%' }
        ]
      }
    },
    warehousesSitesOptions () {
      const allSites = this.isWarehouse ?
        this.warehousesSites
        :
        this.warehouses.reduce((sum, warehouse) => {
          return [...sum, ...warehouse.sites]
        }, [])
      return [{siteName: `-- ${this.$t('all')} --`, key: ''}, ...allSites]
    },
    organizations () {
      return this.sortedWarehouseOrganizations.filter(element => {
        return element.organizationId !== ''
      })
    },
    organizationSelect () {
      return [{displayName: `-- ${this.$t('all')} --`, organizationId: '', key: ''}, ...this.organizations]
    },
    formattedIMEIRecords () {
      return (this.archivedShipmentInEdit.IMEIRecords && this.archivedShipmentInEdit.IMEIRecords.length && this.archivedShipmentInEdit.IMEIRecords.reduce((sum, record) => {
        const {products, tracking} = record
        let formattedRecord = Object.entries(products).map(([upc, item]) => {
          return {
            upc,
            IMEIs: item,
            tracking
          }
        })
        return [...sum, ...formattedRecord]
      }, [])) || []
    }
  },
  methods: {
    async exportOrgData () {
      this.orgExportLoading = true
      try {
        const headers = ['Shipment ID', 'Create Time', 'Product Name', 'UPC', 'Quantity', 'Tracking Number', 'Location', 'Instruction', 'ShipmentId', 'note', 'Order Number']
        const predicates = []

        if (this.orgExportSiteKey) {
          predicates.push({
            field: 'siteKey',
            compare: '==',
            value: this.orgExportSiteKey
          })
        }
        let [startDate, endDate] = this.dates.map((item, index) => {
          switch (+this.timeZone) {
            case 0: {
              const timeFunc = index === 0 ? this.toDateStart : this.toDateEnd
              return timeFunc(item.toISOString().slice(0, 10))
            }
            // case 1: {
            //   const time = index === 0 ? `T00:00:00Z` : `T23:59:59Z`
            //   return new Date(`${format(item, 'yyyy-MM-dd')}${time}`)
            // }
          }
          return item
        })
        const response = await this.$store.dispatch('getArchivedShipments', {
          startDate,
          endDate,
          predicates
        })
        const models = response.models
        if (!models.length) {
          this.$store.dispatch('showToast', {level: 'error', info: this.$t('noDataAvailable')})
          return
        }
        const data = models.reduce((arr, shipment) => {
          const rows = shipment.products.map(product => ([
            String(shipment._key) + '\t',
            toTimestampString(shipment.createTime),
            this.getUpcName(product),
            String(product.upc),
            String(product.toShip),
            String(shipment.trackingNum) + '\t',
            `${shipment.userName} ${product.siteName}`,
            shipment.instruction || '',
            shipment.shipmentId || '',
            shipment.warehouseNote || '',
            shipment.relatedOrder || ''
          ]))
          return [...arr, ...rows]
        }, [])
        exportListToXlsx(
          [headers, ...data],
          'outbound-history'
        )
        this.showOrgExportDialog = false
      } catch (error) {
        console.error(error)
        this.$store.dispatch('showToast', {level: 'error', info: 'export error'})
        throw error
      } finally {
        this.orgExportLoading = false
      }
    },
    async exportExcel () {
      const $pagination = this.$refs.pagination
      const payload = $pagination.getPayload()
      $pagination.addPredicatesToPayload(payload)
      delete payload.limit
      delete payload.startAfter
      this.exportLoading = true
      const rows = await this.$store.dispatch('getArchivedShipments', payload)
      const headers = ['Outbound ID', 'Tracking Number', 'Uploaded Trackings', 'UPC', 'SN', 'Org Name', 'Site Name', 'Product Quantity', 'Confirm Time', 'Technology', 'Printed Time', 'Order Number']
      const data = rows.docs.docs.map(doc => {
        const data = doc.data()
        return {
          ...data,
          createTime: data.createTime.toDate(),
          printedTime: data.printedTime?.toDate(),
          _key: doc.id
        }
      }).reduce((arr, row) => {
        const snArr = row.snRecords.length
          ? row.snRecords
          : ['']
        const value = snArr.reduce((res, item) => {
          row.products.forEach(prd => {
            res.push([
              `\t${row._key}`,
              `\t${row.trackingNum}`,
              row.uploadedTrackings && row.uploadedTrackings.length ? row.uploadedTrackings.join(',') : '',
              prd.upc,
              item,
              row.tenantName,
              row.products[0]?.siteName,
              prd.toShip || 1,
              row.createTime instanceof Date ? row.createTime.toISOString().slice(0, 19).replace('T', ' ') : 'N/A',
              row.isTechShipment || false,
              row.printedTime instanceof Date ? row.printedTime.toISOString().slice(0, 19).replace('T', ' ') : 'N/A',
              row.relatedOrder || ''
            ])
          })
          return res
        }, [])
        return [
          ...arr,
          ...value
        ]
      }, [])
      exportExcelFile(({
        fileName: 'outbound.csv',
        data: [headers, ...data]
      }))
      this.exportLoading = false
    },
    toTimestampString,
    getShipmentLabel (item) {
      let path = item.zipFile.split('/')
      let fileName = path[path.length - 1]
      if (item.zipFile) {
        this.$store.dispatch('downloadFile', {fullPath: item.zipFile, name: fileName})
      }
    },
    showDetails (shipment) {
      this.archivedShipmentInEdit = shipment
      this.outboundAttachments = shipment.attachments || []
      this.photoServiceDialog = true
      this.chatRoomBind = {
        docPath: ['archivedShipments', shipment._key],
        comments: shipment.comments || [],
        readOnly: !this.isWarehouse && !(shipment.userName === 'self' && !shipment.warehouseKey)
      }
    },
    showDraftComments (item, type = 'active') {
      this.draftInEdit = item
      let docPath
      if (type === 'active') {
        docPath = ['shipments', item._key]
      } else if (type === 'draft') {
        docPath = ['tenants', this.$store.getters.activeOrganization, 'shipmentDrafts', item._key]
      } else if (type === 'history') {
        docPath = ['archivedShipments', item._key]
      } else {
        docPath = ['deletedShipments', item._key]
      }
      this.chatRoomBind = {
        lastReadTime: type === 'active' ? undefined : new Date(),
        docPath,
        comments: item.comments || [],
        readOnly: false
      }
      this.draftCommentDialog = true
    },
    displayPackaging (packaging) {
      let {length, width, height} = packaging
      return `${length}"/${width}"/${height}"`
    },
    getSiteName (siteKey) {
      if (!siteKey) return ''
      return (this.warehousesSitesOptions.find(site => site.key === siteKey) || {siteName: '', key: ''}).siteName
    },
    getUpcName (product) {
      const {name, upc} = product
      if (this.isWarehouse) return this.$store.getters.getUpcName(upc)
      return name
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OutBoundHistoryTable.vue